export default {
    COLUMN_TYPES: {
        PERCENT: 'percent',
        NUMBER: 'number',
        DATE: 'date',
        DATE_TIME: 'dateTime',
        CURRENCY: 'currency',
    },
};
